export function groupByValue(inputMap) {
    return [...inputMap].reduce((map, item) => {
        const value = item[0], key = item[1];
        if (!map.has(key))
            map.set(key, []);
        map.get(key).push(value);
        return map;
    }, new Map());
}
export function invert(map) {
    const array = Array.from(map, entry => entry.reverse());
    return new Map(array);
}
